import { area } from "@/mock/area";
import { productType } from "@/mock/product";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
    scopedSlots: {
      customRender: "pkgCode",
    },
  },
  {
    title: "单/多件",
    dataIndex: "singleProductFlag",
    key: "singleProductFlag",
    width: 100,
    scopedSlots: {
      customRender: "singleProductFlag",
    },
    // customRender: (text, record, index) => {
    //   return text == 1 || text == true ? "单品" : "多品";
    // },
  },
  // {
  //   title: "调拨区域",
  //   dataIndex: "regionCode",
  //   key: "regionCode",
  //   scopedSlots: {
  //     customRender: "fromRegionAction",
  //   },
  // },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  // {
  //   title: "采购单类型",
  //   dataIndex: "purchaseType",
  //   key: "purchaseType",
  //   customRender: (text, record, index) => {
  //     return [
  //       record.bizType == 1
  //         ? "档口采购单"
  //         : record.bizType == 2
  //         ? "线上采购单"
  //         : "普通采购单",
  //       "OEM大货单",
  //       "OEM样品单",
  //     ][text];
  //   },
  // },
  {
    title: "订单来源",
    dataIndex: "systemSource",
    key: "systemSource",
    width: 120,
    customRender: (text, record, index) => {
      // return productType[text].label
      return { 1: "D2C", 2: "B2B" }[text];
    },
  },
  {
    title: "是否组合子商品",
    dataIndex: "combinationProductItemFlag",
    key: "combinationProductItemFlag",
    customRender: (text, record, index) => {
      return text == 1 ? "是" : "否";
    },
  },
  // {
  //   title: "是否组合商品",
  //   dataIndex: "productType",
  //   key: "productType",
  //   customRender: (text, record, index) => {
  //     return text == 3 ? "是" : "否";
  //   },
  // },
  {
    title: "批次包类型",
    dataIndex: "pkgType",
    key: "pkgType",
    width: 120,
    customRender: (text, record, index) => {
      return {
        1: "正常包",
        2: "次品",
        3: "异常",
        4: "异常上报采购",
        10: "自有",
      }[text];
    },
  },
  {
    title: "商品数量",
    dataIndex: "amount",
    key: "amount",
    width: 100,
    scopedSlots: {
      customRender: "amount",
    },
  },
  {
    title: "移库数量",
    dataIndex: "moveNum",
    key: "moveNum",
    width: 150,
    scopedSlots: {
      customRender: "moveNum",
    },
  },

  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
    scopedSlots: {
      customRender: "productName",
    },
  },
  {
    title: "特殊质检要求",
    dataIndex: "specialCheckRequirement",
    key: "specialCheckRequirement",
    scopedSlots: {
      customRender: "specialCheckRequirement",
    },
  },
  // {
  //   title: "移库至",
  //   key: "targetRegion",
  //   dataIndex: "targetRegion",
  //   scopedSlots: {
  //     customRender: "targetRegionAction",
  //   },
  //   // fixed:'right',
  //   width: 140,
  // },
  {
    title: "操作",
    key: "action",
    dataIndex: "id",
    width: 100,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
    // fixed:'right'
  },
];
// test
export const testDataSourceMap = {
  pkgCode: "KSID08374696",
  transferArea: 0,
  multiProduct: 0,
  productSku: "SKU387349634",
  orderSource: "大包",
  checkItems: [
    {
      code: "no_check",
      name: "不检查",
    },
  ],
  amount: 100,
};
